// extracted by mini-css-extract-plugin
module.exports = {"header":"ComplaintsDashboard_header__3E5mB","title":"ComplaintsDashboard_title__fmc9F","grow":"ComplaintsDashboard_grow__3hM_d","deleteRow":"ComplaintsDashboard_deleteRow__3XXsN"};